import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { IconType } from '../../interfaces/icon';

@Component({
  selector: 'un-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IconComponent implements OnInit {
  @Input() theme: IconType = 'outline';
  @Input() type: string;
  @Input() alt?: string;
  @Input() size: string | number = 16;
  // @Input() height: string | number = 16;
  // @Input() width: string | number = 16;
  @Input() ration: '1x1' | '4x3' = '4x3';

  ngOnInit() {
    this.theme ??= 'fill';
  }
}
